import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { DetalleAtencionEntity } from '../../../data/repositories/consult/entities/detalle-atencion.entity';

export class GetDetalleAtencionReportUseCase implements UseCase<{fechaInicio: Date; fechaFin: Date}, DetalleAtencionEntity> {
  constructor(private ConsultRepository: ConsultRepository) {}

  execute(params: {fechaInicio: Date; fechaFin: Date}): Observable<DetalleAtencionEntity> {
    return this.ConsultRepository.getDetalleAtencion(params);
  }
}
